import { gql } from '@common/hooks';

export const TimeZonesQuery = gql`
  query TimeZones {
    timeZones {
      text
      value
    }
  }
`;

export type TimeZonesResponse = {
  timeZones: Option[];
};

export type Option = {
  text: string;
  value: string;
};
